module.exports = __webpack_public_path__ + "img/返校_3.ece89a64.jpg";